import NavBar from '../NavBar'
import styles from './TrainMachine.module.css'
import selectbarY from '../../../Assets/Bisoft_UI/AppMode/selectbar.png'
import nextY from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/next.png'
import backY from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/back.png'
import { useRef, useState, useEffect } from 'react'
import { jsPlumb } from 'jsplumb'
import LeftTrainingClass from './LeftTrainingClass'
import CamModule from './CamModel'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'
import AudioModule from './AudioModel'
import { useIndexedDB } from 'react-indexed-db'
import * as tf from '@tensorflow/tfjs'
import { ColorRing } from 'react-loader-spinner'
import { relative, resolve } from 'path'
import renderPrgImage from '../../../source/programImg'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import renderImage from '../../../source/importImg'
import { randomNumberGenerator } from '../../../redux/reducers/appModeStorage'
// import { jsplumb } from 'jsplumb'

const MOBILE_NET_INPUT_WIDTH = 224
const MOBILE_NET_INPUT_HEIGHT = 224

let send = false
let predict = false
let CLASS_NAMES = []
let classColor = []
let trainingDataInputs = []
let trainingDataOutputs = []
let model

// const randomNumberGenerator = () =>
//     Math.floor(100000000000000 + Math.random() * 900000000000000)

function TrainMachine(props) {
    const history = useHistory()

    const leftContainerRef = useRef(null) // Reference to the left scrollable div
    const connectionContainerRef = useRef(null) // Reference to the container holding the connections
    const jsPlumbInstance = useRef(null) // Reference to jsPlumb instance
    //----------------------------------------------------------------------------------------------------
    const [showWebCamModel, setShowWebCamModel] = useState(false)
    // const [showAudioModel, setShowAudioModel] = useState(false)
    const [imageUpload, setImageUpload] = useState(false)

    const [selectedClass, setSelectedClass] = useState('')
    const isAudioTrain = window.location.pathname === '/AudioTrainMachine'

    // const { update, getAll, deleteRecord } = useIndexedDB('SavedFaces')
    const modelsDb = useIndexedDB('models')
    const [mobilenet, setMobilenet] = useState(null)
    const [startTraining, setStartTraining] = useState(false)
    // const [showAdvance, setShowAdvance] = useState(false)
    const [showEpochsHelp, setShowEpochsHelp] = useState(false)
    const [showBatchHelp, setShowBatchHelp] = useState(false)
    const [activeTab, setActiveTab] = useState('training')
    const [showInputModelName, setShowInputModelName] = useState(false)
    const [modelName, setModelName] = useState('')
    const [modelNameError, setModelNameError] = useState('')
    const [editModelName, setEditModelName] = useState({
        isEdit: false,
        editModelId: '',
        newModelName: '',
    })

    const [showModel, setShowModel] = useState({
        isShow: false,
        message: '',
        type: '',
    })

    const inputRef = useRef(null)
    const modelListRef = useRef(null)

    const currentModel = props.camModels?.find(
        (model) => model?.modelId === props.currentModelId
    )
    // const classes = isAudioTrain ? props.AudioClasses : props.ImageClasses
    const classes = currentModel?.ImageClasses
    const isEnableNextBtn = currentModel?.isGenerateTensor
    const isShowClassDeleteBtn = Object.keys(classes).length > 1
    ///////////////////////////// jsPlumb connection logic start ///////////////////////////////////

    useEffect(() => {
        // Initialize jsPlumb instance
        jsPlumbInstance.current = jsPlumb.getInstance({
            PaintStyle: { stroke: '#000', strokeWidth: 2 },
            Endpoint: ['Dot', { radius: 4 }],
            Connector: ['Bezier', { curviness: 100 }],
            Container: connectionContainerRef.current, // Attach jsPlumb to the connection container
        })

        return () => {
            jsPlumbInstance.current?.reset()
        }
    }, [props.currentModelId])

    useEffect(() => {
        // Connect each left-side div to the train_right div
        const rightDivId = 'train_right-small-div'

        Object.keys(classes).map((ele, ind) => {
            const obj = classes?.[ele]

            const leftDivId = `train_left-div-${obj.id}`
            const existingConnection = jsPlumbInstance.current?.getConnections({
                source: leftDivId,
                target: rightDivId,
            })

            // Avoid duplicate connections
            if (!existingConnection?.length) {
                jsPlumbInstance.current?.connect({
                    detachable: false,
                    source: leftDivId,
                    target: rightDivId,
                    anchors: ['Right', 'Left'],
                })
            }
        })

        // Repaint connections to ensure proper alignment
        jsPlumbInstance.current?.repaintEverything()
    }, [classes, props.currentModelId])

    useEffect(() => {
        // Repaint connections on scroll
        const handleScroll = () => {
            jsPlumbInstance.current?.repaintEverything()
        }

        const leftContainer = leftContainerRef.current
        if (leftContainer) {
            leftContainer.addEventListener('scroll', handleScroll)
        }
        window.addEventListener('resize', handleScroll)

        return () => {
            if (leftContainer) {
                leftContainer.removeEventListener('scroll', handleScroll)
            }
            window.removeEventListener('resize', handleScroll)
        }
    }, []) // Attach scroll listener once on mount

    ///////////////////////////// jsPlumb connection logic end ///////////////////////////////////

    ///////////////////////////// image convert to tansor start ///////////////////////////////////
    useEffect(() => {
        //load the mobilent model
        loadModel()
    }, [])
    //load the mobilent model
    const loadModel = async () => {
        try {
            const URL =
                'https://tfhub.dev/google/tfjs-model/imagenet/mobilenet_v3_small_100_224/feature_vector/5/default/1'
            const model = await tf.loadGraphModel(URL, {
                fromTFHub: true,
            })
            setMobilenet(model)
            console.log('Model loaded')
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const processCapturedImages = async (eachClass, allTensor) => {
        const { capturedImages } = eachClass
        try {
            for (let imageSrc of capturedImages) {
                const img = new Image()
                img.src = imageSrc

                await new Promise((resolve) => {
                    img.onload = async () => {
                        const imgTensor = tf.browser.fromPixels(img)
                        const features = calculateFeatures(imgTensor)
                        await addFeaturesToTensor(features, allTensor)
                        resolve()
                    }
                })
            }
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const calculateFeatures = (tensor) => {
        return tf.tidy(() => {
            const resizedTensor = tf.image.resizeBilinear(
                tensor,
                [MOBILE_NET_INPUT_HEIGHT, MOBILE_NET_INPUT_WIDTH],
                true
            )
            const normalizedTensor = resizedTensor.div(255)
            return mobilenet.predict(normalizedTensor.expandDims()).squeeze()
        })
    }

    const addFeaturesToTensor = async (features, allTensor) => {
        const featureArray = await features.array()
        allTensor.push(featureArray)
    }

    /////////////////////////// image convert to tansor end////////////////////////////

    /////////////////////////// svae in db tansor ////////////////////////////
    //check all classes sample are present
    const checkImagePresent = () => {
        for (const classKey in classes) {
            const capturedImages = classes?.[classKey]?.capturedImages
            if (!capturedImages || capturedImages.length === 0) {
                return { status: true, classKey, imageNumber: 0 }
            }
            if (capturedImages.length < 10) {
                return {
                    status: true,
                    classKey,
                    imageNumber: capturedImages.length,
                }
            }
        }
        return {
            status: false,
            classKey: '',
            imageNumber: 11,
        }
    }

    const base64toBlob = async (image) => {
        const byteCharacters = window.atob(image)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'image/jpeg' })
        const blobUrl = URL.createObjectURL(blob)
        // return blobUrl
        sessionStorage.setItem('img', blobUrl)
    }

    const handelTrain = async () => {
        try {
            if (startTraining || Object.keys(classes).length < 2) {
                return
            }
            if (!mobilenet) {
                setShowModel({
                    isShow: true,
                    message:
                        'Oops! The model is currently loading. Please wait.',
                    type: 'showMessage',
                })
                return
            }

            let checkData = checkImagePresent()
            if (checkData.status) {
                let popupText = ''
                if (checkData.imageNumber === 0) {
                    popupText = `${
                        classes[checkData.classKey].className
                    } has no sample.`
                } else {
                    popupText = `${
                        classes[checkData.classKey].className
                    } has fewer than 10 images. A minimum of 10 images is required for training.`
                }
                setShowModel({
                    isShow: true,
                    message: popupText,
                    type: 'showMessage',
                })
                return
            }

            /** ✅ Add a new model record to IndexedDB */
            const newModel = {
                id: currentModel.modelId,
                modelName: currentModel.modelName,
                epochs: currentModel.epochs,
                batchSize: currentModel.batchSize,
                isGenerateTensor: true,
                ImageClasses: currentModel.ImageClasses,
            }
            const id = await modelsDb.update(newModel)

            setStartTraining(true)
            let classesInfo = []

            for (let classKey in classes) {
                let eachClass = classes[classKey]
                let allTensor = []
                await processCapturedImages(eachClass, allTensor)

                if (eachClass.capturedImages) {
                    // await base64toBlob(
                    //     eachClass.capturedImages[0].split(',')[1]
                    // )
                    // let blobdata = await fetch(
                    //     sessionStorage.getItem('img')
                    // ).then((r) => r.blob())

                    let tensors = JSON.stringify(allTensor)

                    // var reader = new FileReader()
                    // reader.readAsDataURL(blobdata)
                    // reader.onloadend = async function () {
                    // var base64data = reader.result

                    let eachClassInfo = {
                        id: eachClass.id,
                        imagetensors: tensors,
                    }

                    // await update(eachClassInfo)
                    classesInfo.push(eachClassInfo)
                    // }
                }
            }

            await new Promise((resolve) => setTimeout(resolve, 100))
            await prepareModelForTraining(classesInfo)
        } catch (e) {
            setStartTraining(false)
            setShowModel({
                isShow: true,
                message: 'Model training was fail.',
                type: 'showMessage',
            })
            console.error('ERROR', e)
        }
    }

    ///////////////////////////save db end //////////////////////////////
    //add new class
    const addClass = () => {
        try {
            const keys = Object.keys(classes)
            const lastKey = keys[keys.length - 1]
            let classLastNumber = parseInt(lastKey?.split('_')?.[1] || '0')
            if (classLastNumber) {
                classLastNumber = classLastNumber + 1
            } else {
                classLastNumber = 1
            }

            // if (isAudioTrain) {
            //     let data = {
            //         id: randomNumberGenerator(),
            //         className: 'Class' + classLastNumber,
            //         sampleType: 'Audio',
            //         indexedDbId: 'Class' + classLastNumber,
            //         capturedAudio: [],
            //     }
            //     props.setNewClasses({
            //         key: 'Class' + classLastNumber,
            //         data,
            //         classType: 'ImageClasses',
            //     })
            // } else {
            let data = {
                id: Date.now(),
                className: 'Class ' + classLastNumber,
                sampleType: 'Image',
                indexedDbId: 'Class ' + classLastNumber,
                capturedImages: [],
                bgColor:
                    '#' + Math.floor(Math.random() * 16777215).toString(16),
            }
            props.setNewClasses({
                key: 'Class_' + classLastNumber,
                data,
                classType: 'ImageClasses',
            })

            autoScrollLeftContainer()
            // }
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const webCamModelHandel = ({ value, imageUpload, classesObjectKey }) => {
        setShowWebCamModel(value)
        setImageUpload(imageUpload)
        setSelectedClass(classesObjectKey)
    }
    // const audioModelHandel = ({ value, audioUpload, className }) => {
    //     setShowAudioModel(value)
    //     setSelectedClass(className)
    // }

    //handel change the oninput change of advance setting
    const handelAdvanceChange = (e, key) => {
        let advanceSetting = {
            epochs: currentModel.epochs,
            batchSize: currentModel.batchSize,
        }
        advanceSetting[key] = parseInt(e.target.value)

        props.setAdvanceSetting(advanceSetting)
    }

    //reset the advance setting state
    const handelReset = () => {
        props.setAdvanceSetting({ epochs: 50, batchSize: 16 })
    }

    //handel next button click
    const nextButtonHandel = () => {
        if (isEnableNextBtn) {
            let enable = JSON.parse(sessionStorage.getItem('enable'))
            enable = {
                ...enable,
                s2: {
                    emotion: false,
                    face: true,
                    object: false,
                },
            }

            sessionStorage.setItem('enable', JSON.stringify(enable))
            history.push('/programmingPage')
        }
    }

    const handelGoNext = () => {
        setShowModel({ isShow: false, message: '', type: '' })
        nextButtonHandel()
    }

    const getModelOptions = (type) => {
        if (type === 'trainSuccessful') {
            return [
                {
                    text: 'Next',
                    do: () => handelGoNext(),
                },
            ]
        }
        return []
    }

    const validateModelNameExists = (name, modelId) => {
        const trimmed = name.trim()
        const exists = props.camModels.find((ele) => {
            return ele.modelName.trim().toLowerCase() === trimmed.toLowerCase()
        })

        if (exists && exists?.modelId != modelId) {
            return { message: 'Model name already exists', error: true }
        } else if (exists && exists.modelId == modelId) {
            return { message: 'Model name already exists', error: false }
        } else {
            return { message: '', error: false }
        }
    }
    // Validation function
    const validateModelName = (name, modelId) => {
        const trimmed = name.trim()
        const regex = /^[a-zA-Z0-9_ ]+$/ // only letters, numbers, underscores, spaces
        // if (!trimmed) return 'Model name cannot be empty'
        if (trimmed.length > 15) return 'Model name must be max 15 characters'
        if (!regex.test(trimmed))
            return 'Special characters or newlines are not allowed'

        return ''
    }

    //add new model
    const addModel = async () => {
        let classId = Date.now()
        let modelList = props.camModels

        let newModel = {
            modelId: Date.now(),
            modelName: modelName.trim(),
            epochs: 50,
            batchSize: 16,
            ImageClasses: {
                [classId]: {
                    id: classId,
                    className: 'Class 1',
                    sampleType: 'Image',
                    // indexedDbId: 'Class 1',
                    capturedImages: [],
                },
            },
            isGenerateTensor: false,
        }
        modelList.push(newModel)
        props.setModelDetails(modelList)
    }

    //delete model
    const handelDeleteModel = async (deleteModelId) => {
        let modelList = props.camModels

        if (modelList.length === 1) {
            // alert("You can't delete the only model.")
            return
        }

        // find index of model to delete
        const deleteIndex = modelList.findIndex(
            (ele) => ele.modelId === deleteModelId
        )

        if (deleteIndex === -1) return // model not found

        // delete tensors if present in db
        const deleteModel = modelList[deleteIndex]
        if (deleteModel.isGenerateTensor && deleteModel.ImageClasses) {
            await modelsDb.deleteRecord(deleteModelId)
            // delete specific model
            await tf.io.removeModel(`indexeddb://${deleteModelId}`)
        }

        // remove the model from the list
        modelList = modelList.filter((ele) => ele.modelId !== deleteModelId)

        const currentModelId = currentModel.modelId // assuming you have it in props or redux

        if (currentModelId === deleteModelId) {
            let newCurrentModelId = null

            // try to pick the next model
            if (modelList[deleteIndex]) {
                newCurrentModelId = modelList[deleteIndex].modelId
            }

            // else pick the previous one
            else if (modelList[deleteIndex - 1]) {
                newCurrentModelId = modelList[deleteIndex - 1].modelId
            }

            // set new current model in redux
            if (newCurrentModelId) {
                props.setCurrentModelId(newCurrentModelId)
            }
        }
        props.setModelDetails(modelList)
    }

    //copy the model
    // copy the model
    const handelCopyModel = async (copyModel) => {
        let modelList = [...props.camModels]

        // get all model names
        const existingNames = modelList.map((m) => m.modelName)

        // base name for copy
        const baseName = `${copyModel.modelName}_Copy`
        let finalName = baseName

        // check if same name already exists
        let counter = 1
        while (existingNames.includes(finalName)) {
            counter++
            finalName = `${baseName}_${counter}` // Model (Copy 2)
        }

        // generate new model id
        const newModelId = Date.now()

        const newModel = {
            ...copyModel,
            modelId: newModelId,
            modelName: finalName,
            isGenerateTensor: false,
        }

        modelList.push(newModel)

        props.setModelDetails(modelList)
        // props.setCurrentModelId(newModelId)
    }

    //handel model edit button click
    const editBtnClick = (editModel) => {
        setEditModelName({
            isEdit: true,
            editModelId: editModel.modelId,
            newModelName: editModel.modelName,
        })
    }

    const handelOnchangeEditModelName = (e) =>
        setEditModelName({
            ...editModelName,
            newModelName: e.target.value,
        })

    const handelEditKeyDownInput = (e) => {
        if (e.key === 'Enter') {
            handelEditBlurInput()
        }
    }
    const handelEditBlurInput = (e) => {
        if (!editModelName.newModelName.trim()) {
            setEditModelName({
                isEdit: false,
                editModelId: '',
                newModelName: '',
            })
            return
        }
        const err = validateModelName(editModelName.newModelName)

        if (err) {
            setModelNameError(err)
            setTimeout(() => setModelNameError(''), 2000)
            return
        }
        const { message, error } = validateModelNameExists(
            editModelName.newModelName,
            editModelName.editModelId
        )
        if (error) {
            setModelNameError(message)
            setTimeout(() => setModelNameError(''), 2000)
            return
        }
        if (message === 'Model name already exists') {
            setEditModelName({
                isEdit: false,
                editModelId: '',
                newModelName: '',
            })
            return
        }

        handelEditModel(editModelName)
        setEditModelName({
            isEdit: false,
            editModelId: '',
            newModelName: '',
        })
    }

    //edit the model name
    const handelEditModel = async (editModelName) => {
        let modelList = [...props.camModels]

        // find index of model to edit
        const editIndex = modelList.findIndex(
            (ele) => ele.modelId === editModelName.editModelId
        )
        if (editIndex === -1) return

        const editModel = modelList[editIndex]

        // update the model name
        modelList[editIndex] = {
            ...editModel,
            modelName: editModelName.newModelName.trim(),
        }

        // update IndexedDB if  model data is stored there
        try {
            await modelsDb.getAll()
            const existingModel = await modelsDb.getByID(
                editModelName.editModelId
            )
            if (existingModel) {
                existingModel.modelName = editModelName.newModelName.trim()
                await modelsDb.update(existingModel)
            }
        } catch (error) {
            console.error('Error updating model in IndexedDB:', error)
        }

        props.setModelDetails(modelList)
    }

    const handelChangeModelName = (e) => {
        setModelName(e.target.value)
    }
    const handelKeyDownInput = (e) => {
        if (e.key === 'Enter') {
            handelBlurInput()
        }
    }
    const handelBlurInput = () => {
        if (!modelName.trim()) {
            setShowInputModelName(false)
            setModelName('')
            return
        }
        const err = validateModelName(modelName)
        if (err) {
            setModelNameError(err)
            setTimeout(() => setModelNameError(''), 2000)
            return
        }
        const { message, error } = validateModelNameExists(modelName, '-1')
        if (error) {
            setModelNameError(message)
            setTimeout(() => setModelNameError(''), 2000)
            return
        }
        addModel()
        setShowInputModelName(false)
        setModelName('')
    }

    //on modelClick set the current model name
    const handelModelClick = (modelId) => {
        props.setCurrentModelId(modelId)

        const allDetails =
            JSON.parse(sessionStorage.getItem('allDetails')) || {}

        const keepKeys = ['id', 'sliderValue']
        for (let key in allDetails) {
            const ele = allDetails[key]

            if (ele.option === 'Face Detected') {
                for (let k in ele) {
                    if (k === 'id') continue
                    if (k === 'sliderValue') {
                        ele[k] = '1'
                    } else {
                        ele[k] = null
                    }
                }
            }
        }
        sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
    }

    // Auto-scroll smoothly when input box appears
    useEffect(() => {
        if (showInputModelName && modelListRef.current) {
            setTimeout(() => {
                modelListRef.current.scrollTo({
                    top: modelListRef.current.scrollHeight,
                    behavior: 'smooth',
                })
            }, 100)
        }
    }, [showInputModelName])

    // Auto-scroll smoothly when add new class left side class container
    const autoScrollLeftContainer = () => {
        if (classes && leftContainerRef.current) {
            setTimeout(() => {
                leftContainerRef.current.scrollTo({
                    top: leftContainerRef.current.scrollHeight,
                    behavior: 'smooth',
                })
            }, 100)
        }
    }

    // useEffect(() => {
    const prepareModelForTraining = async (classesInfo) => {
        // if (dataLoaded === true) {
        CLASS_NAMES = []
        trainingDataInputs = []
        trainingDataOutputs = []
        let count = 0

        // Object.keys(allDetails).map((value) => {
        //     if (allDetails[value].option === 'Face Detected') {
        // setIsShowProcess(true)
        // setIsFaceDetected(true)
        // face = true

        classesInfo.map((eachClassInfo) => {
            CLASS_NAMES.push(eachClassInfo.id)
            classColor.push(
                '#' + Math.floor(Math.random() * 16777215).toString(16)
            )
            let tensors = JSON.parse(eachClassInfo.imagetensors)
            tensors.map((tensor) => {
                trainingDataInputs.push(tf.tensor(tensor))
                trainingDataOutputs.push(count)
            })
            count += 1
            console.log(
                'XXXXXXXXXXX',
                CLASS_NAMES,
                trainingDataInputs,
                trainingDataOutputs
            )
        })

        if (CLASS_NAMES.length === 1) {
            CLASS_NAMES.push('UnKnown')
            classColor.push(
                '#' + Math.floor(Math.random() * 16777215).toString(16)
            )
        }
        model = tf.sequential()
        model.add(
            tf.layers.dense({
                inputShape: [1024],
                units: 128,
                activation: 'relu',
            })
        )
        model.add(
            tf.layers.dense({
                units: CLASS_NAMES.length,
                activation: 'softmax',
            })
        )

        model.summary()

        // Compile the model with the defined optimizer and specify a loss function to use.
        model.compile({
            // Adam changes the learning rate over time which is useful.
            optimizer: 'adam',
            // Use the correct loss function. If 2 classes of data, must use binaryCrossentropy.
            // Else categoricalCrossentropy is used if more than 2 classes.
            loss:
                CLASS_NAMES.length === CLASS_NAMES.length
                    ? 'binaryCrossentropy'
                    : 'categoricalCrossentropy',
            // As this is a classification problem you can record accuracy in the logs too!
            metrics: ['accuracy'],
        })

        await trainAndPredict(trainingDataInputs, trainingDataOutputs)
    }

    const trainAndPredict = async (trainingDataInputs, outputs) => {
        const advanceSetting = props.advanceSetting
        console.log(CLASS_NAMES.length, trainingDataInputs)
        tf.util.shuffleCombo(trainingDataInputs, outputs)

        let outputsAsTensor = tf.tensor1d(outputs, 'int32')
        let oneHotOutputs = tf.oneHot(outputsAsTensor, CLASS_NAMES.length)
        let inputsAsTensor = tf.stack(trainingDataInputs)

        await model.fit(inputsAsTensor, oneHotOutputs, {
            shuffle: true,
            // batchSize: 5,
            // epochs: 10,
            batchSize: advanceSetting.batchSize,
            epochs: advanceSetting.epochs,
            callbacks: { onEpochEnd: logProgress },
        })

        outputsAsTensor.dispose()
        oneHotOutputs.dispose()
        inputsAsTensor.dispose()
        // predict = true
        // setIsShowProcess(false)

        await model.save(`indexeddb://${currentModel.modelId}`)
        // await model.save(`downloads://${currentModel.modelName}`)

        setStartTraining(false)
        setShowModel({
            isShow: true,
            message: 'Model training was successful.',
            type: 'trainSuccessful',
        })
        props.setToggleNextBtn(true)

        // setPredict(true);
        // predictLoop()
    }
    const logProgress = (epoch, logs) => {
        console.log('Data for epoch ' + epoch, logs)
    }

    return (
        <div>
            <DialogModal
                show={showModel.isShow}
                text={showModel.message}
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowModel({ isShow: false, message: '', type: '' })
                }
                optionsToSelect={getModelOptions(showModel.type)}
            />

            {/*--------------------- camera model ----------------------*/}
            <CamModule
                selectedClass={selectedClass}
                isShow={showWebCamModel}
                imageUpload={imageUpload}
                handleDialogModalClose={() =>
                    webCamModelHandel({ value: false, imageUpload: false })
                }
            />

            {/*--------------------- Audio Model ----------------------*/}
            {/* <AudioModule
                className={selectedClass}
                isShow={showAudioModel}
                audioUpload={false}
                handleDialogModalClose={() =>
                    audioModelHandel({ value: false, audioUpload: false })
                }
            /> */}
            {/*--------------------- NavBar ----------------------*/}
            <div>
                <NavBar
                    selectbar={selectbarY}
                    selectbarwidth="20%"
                    headers={[
                        { name: 'Enable', color: 'white' },
                        { name: 'Control', color: 'black' },
                        { name: 'Run', color: 'black' },
                    ]}
                    showHelp={true}
                    // handleHelp={handleClickhelpbtn}
                />
            </div>
            {/* -------------------- body ------------------------------ */}
            <div
                className={styles.train_parent}
                // style={{ border: '1px solid red' }}
            >
                {/* Left scrollable div */}
                <div
                    // style={{ border: '1px solid green' }}
                    className={styles.train_left}
                    ref={leftContainerRef}
                >
                    {Object.keys(classes).map((ele, ind) => {
                        const obj = classes?.[ele]
                        return (
                            <div
                                key={obj.id}
                                id={`train_left-div-${obj.id}`}
                                className={styles['train_left-small-div']}
                            >
                                <LeftTrainingClass
                                    jsPlumbInstance={jsPlumbInstance.current}
                                    isAudioTrain={isAudioTrain}
                                    obj={obj}
                                    classesObjectKey={ele}
                                    webCamModelOpen={webCamModelHandel}
                                    classes={classes}
                                    // audioModelOpen={audioModelHandel}
                                    isShowClassDeleteBtn={isShowClassDeleteBtn}
                                />
                            </div>
                        )
                    })}

                    <div className={styles['addBtn-div']}>
                        <img
                            src={renderImage('buttonPlusImg')}
                            alt="next"
                            draggable="false"
                            style={{
                                margin: 0,
                                width: '3vw',
                                cursor: 'pointer',
                            }}
                            onClick={addClass}
                        />
                    </div>
                </div>

                {/* Connection container */}
                <div
                    className={styles['train_connection-container']}
                    ref={connectionContainerRef}
                ></div>

                {/*---------------- Right div -----------------------*/}
                <div
                    // style={{ border: '1px solid green' }}
                    className={styles.train_right}
                >
                    <div
                        className={styles['train_right-small-div']}
                        id="train_right-small-div"
                    >
                        {/* <p className={styles['train_right_tranText']}>
                            Training
                        </p> */}
                        <p className={styles['ModelHeader']}>
                            Model: {currentModel.modelName}
                        </p>
                        <div className={styles.toggleContainer}>
                            <div
                                className={`${styles.toggleBackground} ${
                                    activeTab === 'models' ? styles.right : ''
                                }`}
                            ></div>

                            <button
                                className={`${styles.toggleButton} ${
                                    activeTab === 'training'
                                        ? styles.active
                                        : ''
                                }`}
                                onClick={() => setActiveTab('training')}
                            >
                                Training
                            </button>
                            <button
                                className={`${styles.toggleButton} ${
                                    activeTab === 'models' ? styles.active : ''
                                }`}
                                onClick={() => setActiveTab('models')}
                            >
                                Models
                            </button>
                        </div>

                        {activeTab === 'training' ? (
                            <>
                                {' '}
                                <div className={styles.advanceDiv}>
                                    <div className={styles.epochsDiv}>
                                        <div className={styles.epochsDivInr}>
                                            <p style={{ marginBottom: '0' }}>
                                                Epochs:
                                            </p>
                                            <input
                                                type="number"
                                                value={currentModel.epochs}
                                                onChange={(e) =>
                                                    handelAdvanceChange(
                                                        e,
                                                        'epochs'
                                                    )
                                                }
                                            />
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    textAlign: 'right',
                                                    width: '25px',
                                                }}
                                                onMouseEnter={() =>
                                                    setShowEpochsHelp(true)
                                                }
                                                onMouseLeave={() =>
                                                    setShowEpochsHelp(false)
                                                }
                                            >
                                                <img
                                                    width={'20px'}
                                                    src={renderPrgImage(
                                                        'questionPng'
                                                    )}
                                                    alt="arrow down"
                                                />
                                                <div
                                                    className={`${
                                                        styles.epochsHelpDiv
                                                    } ${
                                                        showEpochsHelp
                                                            ? styles.epochsHelpDivShow
                                                            : ''
                                                    }`}
                                                >
                                                    <p>
                                                        One epoch means that
                                                        each and every sample in
                                                        the training dataset has
                                                        been fed through the
                                                        training model at least
                                                        once. If your epochs are
                                                        set to 50, for example,
                                                        it means that the model
                                                        you are training will
                                                        work through the entire
                                                        training dataset 50
                                                        times. Generally the
                                                        larger the number, the
                                                        better your model will
                                                        learn to predict the
                                                        data.
                                                    </p>
                                                    <p>
                                                        You probably want to
                                                        tweak (usually increase)
                                                        this number until you
                                                        get good predictive
                                                        results with your model.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.batchDiv}>
                                        <div className={styles.batchDivInr}>
                                            <p style={{ marginBottom: '0' }}>
                                                Batch Size:
                                            </p>

                                            <select
                                                value={currentModel.batchSize}
                                                onChange={(e) =>
                                                    handelAdvanceChange(
                                                        e,
                                                        'batchSize'
                                                    )
                                                }
                                            >
                                                <option value="16">16</option>
                                                <option value="32">32</option>
                                                <option value="64">64</option>
                                                <option value="128">128</option>
                                                <option value="256">256</option>
                                                <option value="512">512</option>
                                            </select>
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    textAlign: 'right',
                                                    width: '25px',
                                                }}
                                                onMouseEnter={() =>
                                                    setShowBatchHelp(true)
                                                }
                                                onMouseLeave={() =>
                                                    setShowBatchHelp(false)
                                                }
                                            >
                                                <img
                                                    width={'20px'}
                                                    src={renderPrgImage(
                                                        'questionPng'
                                                    )}
                                                    alt="arrow down"
                                                />
                                                <div
                                                    className={`${
                                                        styles.batchHelpDiv
                                                    } ${
                                                        showBatchHelp
                                                            ? styles.epochsHelpDivShow
                                                            : ''
                                                    }`}
                                                >
                                                    <p>
                                                        A batch is a set of
                                                        samples used in one
                                                        iteration of training.
                                                        For example, let's say
                                                        that you have 80 images
                                                        and you choose a batch
                                                        size of 16. This means
                                                        the data will be split
                                                        into 80 / 16 = 5
                                                        batches. Once all 5
                                                        batches have been fed
                                                        through the model,
                                                        exactly one epoch will
                                                        be complete.
                                                    </p>
                                                    <p>
                                                        You probably won't need
                                                        to tweak this number to
                                                        get good training
                                                        results.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.resetDiv}>
                                        <div
                                            onClick={handelReset}
                                            className={styles.resetDivInr}
                                        >
                                            <p style={{ marginBottom: '0' }}>
                                                Reset Defaults
                                            </p>
                                            <img
                                                width={'20px'}
                                                src={renderPrgImage('reset')}
                                                alt="arrow down"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        position: 'relative',
                                    }}
                                >
                                    <p
                                        onClick={handelTrain}
                                        className={
                                            styles['train_right_tainButton']
                                        }
                                        style={
                                            startTraining ||
                                            Object.keys(classes).length < 2
                                                ? {
                                                      opacity: '0.5',
                                                      cursor: 'default',
                                                  }
                                                : {}
                                        }
                                    >
                                        {startTraining
                                            ? 'Training...'
                                            : 'Train Model'}
                                    </p>

                                    {/* {startTraining && (
                                <div
                                    className={styles['trainLodarStyle']}
                                    style={{}}
                                >
                                    <ColorRing />
                                </div>
                            )} */}
                                </div>
                            </>
                        ) : (
                            <div
                                className={styles['modelContainer']}
                                style={{
                                    position: 'relative',
                                }}
                            >
                                <div
                                    className={styles['modelList']}
                                    ref={modelListRef}
                                    // style={{ border: '1px solid red' }}
                                >
                                    {props.camModels.map((ele, id) => (
                                        <>
                                            {editModelName.editModelId ==
                                            ele.modelId ? (
                                                <div
                                                    className={
                                                        styles.modelNameInputDiv
                                                    }
                                                >
                                                    <input
                                                        style={{
                                                            marginBottom:
                                                                '10px',
                                                        }}
                                                        className={
                                                            styles.modelNameInput
                                                        }
                                                        type="text"
                                                        placeholder="Enter model name"
                                                        onChange={
                                                            handelOnchangeEditModelName
                                                        }
                                                        value={
                                                            editModelName.newModelName
                                                        }
                                                        onKeyDown={
                                                            handelEditKeyDownInput
                                                        }
                                                        onBlur={
                                                            handelEditBlurInput
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    key={ele.modelName
                                                        .trim()
                                                        .replace(/\s+/g, '_')}
                                                    className={
                                                        styles.eachModelDiv
                                                    }
                                                    onClick={() =>
                                                        handelModelClick(
                                                            ele.modelId
                                                        )
                                                    }
                                                    style={
                                                        props.currentModelId ===
                                                        ele.modelId
                                                            ? {
                                                                  background:
                                                                      'linear-gradient(to right,rgb(244, 167, 86),rgb(242, 129, 104))',
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <div
                                                        className={
                                                            styles.eachModelName
                                                        }
                                                    >
                                                        {ele.modelName}
                                                    </div>
                                                    <div
                                                        className={
                                                            styles.modelMenuDiv
                                                        }
                                                    >
                                                        <div
                                                            style={{
                                                                position:
                                                                    'relative',
                                                            }}
                                                        >
                                                            <img
                                                                id={
                                                                    styles.modelNameEditImg
                                                                }
                                                                width={'23px'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                src={renderPrgImage(
                                                                    'editPencil'
                                                                )}
                                                                alt="Edit model name"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation()
                                                                    editBtnClick(
                                                                        ele
                                                                    )
                                                                }}
                                                            />
                                                            <div
                                                                className={`${styles.tooltipDiv} ${styles.modelNameEditImgToolTip}`}
                                                            >
                                                                Edit model name
                                                            </div>
                                                        </div>

                                                        <div
                                                            style={{
                                                                position:
                                                                    'relative',
                                                            }}
                                                        >
                                                            <img
                                                                width={'23px'}
                                                                // ref={menuIconRef}
                                                                id={
                                                                    styles.deleteModelImg
                                                                }
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                src={renderPrgImage(
                                                                    'deleteEnable'
                                                                )}
                                                                alt="Delete model"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation()
                                                                    handelDeleteModel(
                                                                        ele.modelId
                                                                    )
                                                                }}
                                                            />
                                                            <div
                                                                className={`${styles.tooltipDiv} ${styles.deleteModelImgToolTip}`}
                                                            >
                                                                Delete model
                                                            </div>
                                                        </div>

                                                        <div
                                                            style={{
                                                                position:
                                                                    'relative',
                                                            }}
                                                        >
                                                            <img
                                                                id={
                                                                    styles.modelNameEditImg
                                                                }
                                                                width={'23px'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                src={renderImage(
                                                                    'ActionCopyBtn'
                                                                )}
                                                                alt="Copy model"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation()
                                                                    handelCopyModel(
                                                                        ele
                                                                    )
                                                                }}
                                                            />
                                                            <div
                                                                className={`${styles.tooltipDiv} ${styles.modelNameEditImgToolTip}`}
                                                            >
                                                                Copy model name
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ))}

                                    {showInputModelName && (
                                        <div
                                            className={styles.modelNameInputDiv}
                                        >
                                            <input
                                                className={
                                                    styles.modelNameInput
                                                }
                                                type="text"
                                                placeholder="Enter model name"
                                                onChange={handelChangeModelName}
                                                value={modelName}
                                                onKeyDown={handelKeyDownInput}
                                                onBlur={handelBlurInput}
                                            />

                                            {/* {modelNameError && (
                                                <p
                                                    className={
                                                        styles.modelNameInputError
                                                    }
                                                >
                                                    {modelNameError}
                                                </p>
                                            )} */}
                                        </div>
                                    )}
                                </div>

                                {modelNameError && (
                                    <p className={styles.modelNameInputError}>
                                        {modelNameError}
                                    </p>
                                )}

                                <div className={styles.modelAddButton}>
                                    <img
                                        src={renderImage('buttonPlusImg')}
                                        alt="next"
                                        draggable="false"
                                        width={'25px'}
                                        style={{
                                            margin: 0,

                                            cursor: 'pointer',
                                        }}
                                        onClick={() =>
                                            setShowInputModelName(true)
                                        }
                                    />
                                </div>
                            </div>
                        )}

                        {/* ------------------- Advance Setting ----------------------------- */}

                        {/* <div className={styles.advanceBtnDiv}>
                            <div
                                className={styles.advanceBtnInrDiv}
                                onClick={() => setShowAdvance(!showAdvance)}
                            >
                                Advance Settings
                                {showAdvance ? (
                                    <img
                                        width={'24px'}
                                        src={renderPrgImage('arrowUpActive')}
                                        alt="arrow down"
                                    />
                                ) : (
                                    <img
                                        width={'36px'}
                                        src={renderPrgImage('arrowDown')}
                                        alt="arrow down"
                                    />
                                )}
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* ------------------- add button ----------------------------- */}
            {/* <div onClick={addClass} className={styles.TrainingClassAddButton}>
                Add Class
            </div> */}

            {/*--------------- Footer -------------------------*/}
            <div>
                <img
                    src={nextY}
                    alt="next"
                    draggable="false"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '92vh',
                        left: '95.8vw',
                        width: '3vw',
                        cursor: isEnableNextBtn ? 'pointer' : 'default',
                        transform: 'translate(-50%, -50%)',
                        opacity: isEnableNextBtn ? '1' : '0.5',
                    }}
                    onClick={() => nextButtonHandel()}
                />

                <img
                    src={backY}
                    alt="back"
                    draggable="false"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '92vh',
                        right: '92.7vw',
                        width: '3vw',
                        cursor: 'pointer',
                        transform: 'translate(-50%, -50%)',
                    }}
                    onClick={() => history.push('/chooseDevice')}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        appModeStorage: state.appModeStorage,
        // ImageClasses: state.appModeStorage.trainMachine.ImageClasses,
        // AudioClasses: state.appModeStorage.trainMachine.AudioClasses,
        advanceSetting: state.appModeStorage.trainMachine.advanceSetting,
        // isEnableNextBtn: state.appModeStorage.trainMachine.isEnableNextBtn,
        camModels: state.appModeStorage.trainMachine.camModels,
        currentModelId: state.appModeStorage.trainMachine.currentModelId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setNewClasses: (data) => {
            dispatch({ type: 'ADD_CLASSES', payload: data })
        },
        setAdvanceSetting: (data) => {
            dispatch({ type: 'ADVANCE_SETTING', payload: data })
        },

        setToggleNextBtn: (data) => {
            dispatch({ type: 'TOGGLE_NEXT_BTN', payload: data })
        },
        setModelDetails: (data) => {
            dispatch({ type: 'SET_MODEL_DETAILS', payload: data })
        },
        setCurrentModelId: (data) => {
            dispatch({ type: 'SET_CURRENT_MODEL_ID', payload: data })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainMachine)
